/* eslint-disable @typescript-eslint/no-unused-vars */

export const handlePosition = (
  position: any,
  referenceId: string,
  lastCordinateDate: Date,
  started: boolean,
  interval: number,
) => {};

export const startWatchPosition = async (
  interval: number,
  referenceId: string,
  setTaskId: (id: number | null) => void,
) => {};

export const androidWatchPosition = async (
  interval: number,
  referenceId: string,
) => {};
